import type { IAssistantCreatedNotificationData } from "@frontend-shared/types";
import { Bot } from "lucide-react";
import { memo, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IAssistantCreatedCardProps {
  uuid: string;
  data: IAssistantCreatedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewAssistants: (projectUuid: string) => void;
}

const AssistantCreatedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewAssistants,
}: IAssistantCreatedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  const handleViewAssistants = useCallback(
    () => onViewAssistants(data.projectUuid),
    [onViewAssistants, data.projectUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="assistant_created"
      createdAt={createdAt}
      isRead={isRead}
      icon={<Bot className="h-5 w-5 text-indigo-500" />}
      iconBgClassName="bg-indigo-500/10"
      ctaLabel={t("view_assistants")}
      onCtaClick={handleViewAssistants}
      body={
        <Trans
          ns="notifications"
          i18nKey="type.assistant_created.body"
          values={{
            creatorName: data.creatorName,
            assistantName: data.assistantName,
            projectTitle: data.projectTitle,
          }}
          components={{ b: <strong /> }}
        />
      }
    />
  );
};

export const AssistantCreatedCard = memo(AssistantCreatedCardComponent);
